<form [formGroup]="resetForm" (ngSubmit)="changePassword(resetForm.value)">
  <ion-input type="text" formControlName="loginId"></ion-input>
  <ion-button type="submit" strong shape="round" [disabled]="!resetForm.valid">
    {{ buttonLabel }}
  </ion-button>
</form>
